import { render, staticRenderFns } from "./NewsEdit.vue?vue&type=template&id=2b768c7a&scoped=true&"
import script from "./NewsEdit.vue?vue&type=script&lang=js&"
export * from "./NewsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b768c7a",
  null
  
)

export default component.exports